import {API_URL_FINTECH} from '../constants';

export const apiBaseCards = {
  baseUrl: API_URL_FINTECH,
  endpoints: {
    getCards: '/card/v1',
    schedulePhysicalCard: '/card/v1/physical-request',
  },
};
